<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Editar Distribuidor</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <distributor-form
          v-if="isDataLoaded"
          :distributor="distributor"
          :server-errors="serverErrors"
          :title="`Editar distribuidor: ${distributor.name}`"
          @save="saveDistributor"
        >
        </distributor-form>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import DistributorForm from './Forms/DistributorForm';
import swal from 'sweetalert2';

export default {
  name: 'DistributorsEdit',
  components: {
    RouteBreadCrumb,
    DistributorForm,
  },

  data() {
    return {
      isDataLoaded: false,
      distributor: null,
      serverErrors: [],
    };
  },

  created() {
    const distributorId = this.$route.params.id;
    this.fetchDistributor(distributorId);
  },

  methods: {
    fetchDistributor(distributorId) {
      let params = {
        include: ['seller', 'city.province'],
      };

      this.$services
        .resource('distributors')
        .show(distributorId, params)
        .then((res) => res.data.data)
        .then((distributor) => {
          distributor.seller = distributor.sellerId;
          this.distributor = distributor;
          this.isDataLoaded = true;
        });
    },

    saveDistributor(distributor) {
      this.serverErrors = [];
      this.$services
        .resource('distributors')
        .update(this.distributor.id, distributor)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'El distribuidor fue actualizado.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          });
          this.$router.push({ name: 'DistributorsList' });
        })
        .catch((errors) => {
          this.serverErrors = errors;
        });
    },
  },
};
</script>
